//export const systemUrl = 'http://localhost/dropshipper/app/';
export const systemUrl =  window.location.hostname.includes("localhost") ? 'http://localhost/dropshipper/app/' :'https://drop.gurus.co.il/app/';



//const token = '1920837902173901273091';

const fetchData = async (postData) => {
    try {
        
        let systemUrlLocal = systemUrl + postData.action ;        

        if (postData.url) {
            systemUrlLocal = postData.url
        }


        console.log(systemUrlLocal,postData)

        const response = await fetch(systemUrlLocal , {
            method: 'POST',
            //mode: 'no-cors',
            //credentials: 'include',
            // headers: {
            //     'Content-Type': 'application/json',
            // },
            timeout: 5000,
            body: JSON.stringify(postData),
            cache: 'no-cache',
            redirect: 'follow',
            referrer: 'no-referrer',
        });
        const result = await response.json();
        return result;
    } catch (err) {
        console.error('Error fetching data:', err);
        let error = err;
        return false;
    }
};



export default fetchData;